import { CircleMarker, Tooltip } from "react-leaflet";
import type { CellFeature } from "../../types/cell";
import { riskScale } from "../../lib/colormap";
import { useUIStore, pushUrl } from "../../store/uiStore";

interface Props {
  features: CellFeature[];
}

export function ChoroplethLayer({ features }: Props) {
  const selectCell = useUIStore((s) => s.selectCell);

  function getColor(f: CellFeature): string {
    return riskScale(f.properties.p_hat).hex();
  }

  function handleClick(cellId: string) {
    selectCell(cellId);
    pushUrl({ selectedCellId: cellId });
  }

  return (
    <>
      {features.map((f) => {
        const [lng, lat] = f.geometry.coordinates;
        const color = getColor(f);
        return (
          <CircleMarker
            key={f.properties.cell_id}
            center={[lat, lng]}
            radius={5}
            pathOptions={{
              fillColor: color,
              fillOpacity: 0.85,
              color: "#fff",
              weight: 0.5,
            }}
            eventHandlers={{ click: () => handleClick(f.properties.cell_id) }}
          >
            <Tooltip>
              <div style={{ fontSize: 12 }}>
                <div><strong>{f.properties.cell_id}</strong></div>
                <div>Risk: {(f.properties.p_hat * 100).toFixed(1)}%</div>
              </div>
            </Tooltip>
          </CircleMarker>
        );
      })}
    </>
  );
}
